import { render, staticRenderFns } from "./node-label.vue?vue&type=template&id=3019b52e&scoped=true&"
import script from "./node-label.vue?vue&type=script&lang=ts&"
export * from "./node-label.vue?vue&type=script&lang=ts&"
import style0 from "./node-label.vue?vue&type=style&index=0&id=3019b52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019b52e",
  null
  
)

export default component.exports